import React from 'react'
import SecondaryButton from './SecondaryButton'

const CancelButton = ({ labelId = 'action.cancel', ...props }) => (
  <SecondaryButton labelId={labelId} {...props} />
)

export default CancelButton
